import { toast } from "react-toastify";
import LogoSmall from "../../assets/images/logo-small.png";
import floatingSound from "../../assets/audios/floating-notification-tone.wav";
import newMessageSound from "../../assets/audios/new-message-tone.mpeg";
import { axiosInstance } from "../../redux/constants/axiosInstance";
import { API_URL, CHAT_API_URL } from "../../redux/constants/type";
import { useDispatch, useSelector } from "react-redux";
import { GroupInfo, UnArchiveChat, UndoDeleteChat } from "../../redux/actions/chatActions";
import { memo, useEffect, useState } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { useMemo } from "react";
import {
  deleteTask,
  getUserNotifications,
  user_logout,
} from "../../redux/actions/action";
import { useHistory } from "react-router-dom";
import { convertFromRaw } from "draft-js";
import moment from "moment";

const UserNotification = memo(() => {
  const dispatch = useDispatch();
  const [connection, setConnection] = useState(null);
  const currentUserId = useMemo(() => window.localStorage.getItem("userid"));
  const currentCompanyId = useMemo(() =>
    window.localStorage.getItem("companyid")
  );

  const refreshNotifications = () => {
    if (currentUserId) {
      dispatch(getUserNotifications(currentUserId));
    }
  };

  useEffect(() => {
    setupSignalrForNotification();
    const unsubscribe = toast.onChange((payload) => {
      if (payload.status === "added" && payload.data.sound) {
        payload.data.sound.play();
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const setupSignalrForNotification = () => {
    Object.defineProperty(WebSocket, "OPEN", { value: 1 });
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${CHAT_API_URL}/notification`, {
        withCredentials: true,
        accessTokenFactory: () =>
          Promise.resolve(window.localStorage.getItem("token")),
      })
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  };

  useEffect(() => {
    let refreshTimerId = null;

    if (connection) {
      connection
        .start()
        .then(() => {
          refreshNotifications();
          connection.on("new-message-notification", (userids, notification) => {
            if (userids && userids.includes(currentUserId)) {
              NewMessageNotification(notification);
            }
          });
          connection.on("force-logout", (userids) => {
            if (userids && userids === currentUserId) {
              // dispatch(user_logout(currentUserId));
            }
          });
          connection.on("chat-update", (notificationData) => {
            if (
              notificationData &&
              notificationData.reciverUserIds.includes(currentUserId)
            ) {
              handleChatUpdate(notificationData);
            }
          });
          connection.on("new-notification", (recipientId) => {
            if (recipientId && recipientId === currentUserId) {
              refreshNotifications();
            }
          });
          connection.on("notification-update", (users, excluded) => {
            if (users) {
              if (excluded && !users.includes(currentUserId)) {
                refreshNotifications();
              } else if (!excluded && users.includes(currentUserId)) {
                refreshNotifications();
              }
            }
          });
          connection.on("general-notification", (user, notificationData) => {
            if (user && user === currentUserId) {
              refreshNotifications();
              handleGeneralNotification(notificationData);
            }
          });
          connection.onreconnected(() => {
            refreshNotifications();
          });

          refreshTimerId = setInterval(() => {
            refreshNotifications();
          }, 60000);
        })
        .catch((e) => { });
    }

    return () => {
      if (refreshTimerId) {
        clearInterval(refreshTimerId);
      }
      if (connection) {
        connection.invoke("LeaveGroup", `${currentCompanyId}`);
      }
    };
  }, [connection, currentCompanyId, currentUserId]);

  return null;
});

export default UserNotification;

export const ShowUndoNotification = (groupId = "", type) => {
  toast.dismiss();
  toast(<UndoNotificationMessage groupId={groupId} type={type} />, {
    icon: () => <img src={LogoSmall} width={35} />,
    className: "app-notification",
    data: {
      sound: new Audio(floatingSound),
    },
  });
};

export const NewMessageNotification = (message) => {
  toast.dismiss();
  toast(<NewMessageNotificationMessage message={message} />, {
    icon: () => <ChatUserImage message={message} />,
    className: "app-notification",
    data: {
      sound: new Audio(newMessageSound),
    },
  });
};

export const handleChatUpdate = (notificationData) => {
  toast.dismiss();
  toast(<ChatUpdateNotification notificationData={notificationData} />, {
    icon: () => <img src={LogoSmall} width={35} />,
    className: "app-notification",
    data: {
      sound: new Audio(floatingSound),
    },
  });
};

export const handleGeneralNotification = (notificationData, sound = true, autoClose = 5000) => {
  toast.dismiss();
  toast(<GeneralNotification notificationData={notificationData} />, {
    icon: () => <img src={LogoSmall} width={35} />,
    autoClose: autoClose || 5000,
    className: "app-notification",
    data: {
      sound: sound ? new Audio(floatingSound) : null,
    },
  });
};

const UndoNotificationMessage = ({ groupId, type }) => {
  const userId = window.localStorage.getItem("userid");
  const dispatch = useDispatch();

  const handleOnUndoClick = () => {
    toast.dismiss();
    axiosInstance
      .post(`${API_URL}/api/Chatting/UnmuteNotification`, { groupId, userId })
      .then(() => {
        dispatch(GroupInfo(userId, groupId));
      });
  };
  return (
    <div className="app-notification-container">
      The notifications for this {type === "Group" ? "group" : "chat"} have been
      muted.{" "}
      <span className="redirect-link" onClick={handleOnUndoClick}>
        Undo.
      </span>
    </div>
  );
};

const NewMessageNotificationMessage = ({ message }) => {
  const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  const getFormattedText = () => {
    if (isJson(message.messagetext)) {
      return convertFromRaw(JSON.parse(message.messagetext)).getPlainText();
    }
    return message.messagetext;
  };

  return (
    <div
      style={{
        fontSize: "14px",
        lineHeight: "19px",
        fontWeight: "normal",
        color: "#000000",
        padding: 5,
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
      }}>
      <span
        style={{
          fontSize: "14px",
          lineHeight: "19px",
          fontWeight: "bolder",
          color: "#00246A",
        }}>
        {message.senderName}:{" "}
      </span>
      {getFormattedText()}
    </div>
  );
};

const ChatUpdateNotification = ({ notificationData }) => {
  const history = useHistory();
  const redirectToChat = () => {
    toast.dismiss();
    history.push(`/chat?room=${notificationData.groupId}`);
  };

  const GetTextLink = () => {
    if (notificationData.notificationType == "ADDED") {
      return (
        <>
          {notificationData.senderName} added you to the group{" "}
          <span className="redirect-link" onClick={redirectToChat}>
            {notificationData.groupName}.
          </span>
        </>
      );
    }
    if (notificationData.notificationType == "REMOVED") {
      return (
        <>
          {notificationData.senderName} has removed you from the chat{" "}
          {notificationData.groupName}.
        </>
      );
    }
    if (notificationData.notificationType == "ADMIN") {
      return (
        <>
          {notificationData.senderName} has given you the{" "}
          <span className="redirect-link" onClick={redirectToChat}>
            chat
          </span>{" "}
          admin role.
        </>
      );
    }
    return <></>;
  };
  return (
    <div className="app-notification-container">
      <GetTextLink />
    </div>
  );
};

const GeneralNotification = ({ notificationData }) => {
  const history = useHistory();
  const innerData = notificationData.data
    ? JSON.parse(notificationData.data)
    : null;
  const dispatch = useDispatch();

  const redirectToChat = () => {
    toast.dismiss();
    switch (notificationData.notificationType) {
      case "TASK_ASSIGN":
      case "TASK_DUE_DATE_CHANGE":
      case "TASK_DUE_TIME_CHANGE":
      case "TASK_STATUS_CHANGE":
      case "TASK_DUE":
      case "COMMENT_TAGGED":
        window.localStorage.setItem("taskid", innerData.taskId);
        if (window.location.pathname == "/planboard") {
          window.location.reload();
        } else {
          history.push("/planboard");
        }
        break;
      case "RESET_PASSWORD":
        window.localStorage.clear();
        window.localStorage.clear();
        history.push("/");
        break;
      case "TASK_DELETED":
        dispatch(deleteTask(innerData.taskId, true));
        break;
      case "QUOTE_SIGNED":
        window.open(innerData.quoteLink, "_blank");
        break;
      case "CHAT_ARCHIVE":
        dispatch(UnArchiveChat({ groupid: innerData.groupid }))
        break;
      case "CHAT_DELETE":
        dispatch(UndoDeleteChat(innerData))
        break;
      default:
        break;
    }
  };

  const GetTextLink = () => {
    if (notificationData.notificationType == "TASK_ASSIGN") {
      return (
        <>
          {notificationData.title} assigned{" "}
          <span className="redirect-link" onClick={redirectToChat}>
            {innerData.taskname}
          </span>{" "}
          to you.
        </>
      );
    }
    if (notificationData.notificationType == "TASK_DUE_DATE_CHANGE") {
      return (
        <>
          {notificationData.title} updated due date to{" "}
          {moment(innerData.duedate).utc().format("DD/MM/YYYY")} for{" "}
          <span className="redirect-link" onClick={redirectToChat}>
            {innerData.taskname}
          </span>{" "}
          task.
        </>
      );
    }
    if (notificationData.notificationType == "TASK_DUE_TIME_CHANGE") {
      return (
        <>
          {notificationData.title} updated due time to{" "}
          {moment(innerData.duedate).utc().format("HH:mm")} for{" "}
          <span className="redirect-link" onClick={redirectToChat}>
            {innerData.taskname}
          </span>{" "}
          task.
        </>
      );
    }
    if (notificationData.notificationType == "TASK_STATUS_CHANGE") {
      return (
        <>
          {notificationData.title} moved{" "}
          <span className="redirect-link" onClick={redirectToChat}>
            {innerData.taskname}
          </span>{" "}
          to {innerData.status}.
        </>
      );
    }
    if (notificationData.notificationType == "TASK_DUE") {
      return (
        <>
          Don't forget, this task is due today:{" "}
          <span className="redirect-link" onClick={redirectToChat}>
            {innerData.taskname}
          </span>
          .
        </>
      );
    }
    if (notificationData.notificationType == "TASK_DELETED") {
      if (innerData.canUndo) {
        return (
          <>
            The {innerData.taskname} task is deleted:{" "}
            <span className="redirect-link" onClick={redirectToChat}>
              Undo
            </span>
            .
          </>
        );
      } else {
        return (
          <>
            {notificationData.title} deleted task {innerData.taskname}.
          </>
        );
      }
    }
    if (notificationData.notificationType == "RESET_PASSWORD") {
      setTimeout(() => {
        history.push("/");
      }, 4000);
      return (
        <>
          Password recovered successfully! <br /> Please{" "}
          <span
            className="redirect-link text-decoration-none"
            onClick={redirectToChat}>
            login
          </span>{" "}
          with the new password.
        </>
      );
    }
    if (notificationData.notificationType == "COMMENT_TAGGED") {
      return (
        <>
          {notificationData.title} mentioned you in{" "}
          <span
            className="redirect-link text-decoration-none"
            onClick={redirectToChat}>
            {innerData.taskname}
          </span>
        </>
      );
    }
    if (notificationData.notificationType == "QUOTE_SIGNED") {
      return (
        <>
          Client has signed the quote{" "}
          <span
            className="redirect-link text-decoration-none"
            onClick={redirectToChat}>
            {innerData.quoteCode}
          </span>
        </>
      );
    }
    if (notificationData.notificationType == "CHAT_ARCHIVE") {
      return <>Conversation archived. <br /><span className="redirect-link text-decoration-none" onClick={redirectToChat}>Undo.</span></>
    }
    if (notificationData.notificationType == "CHAT_DELETE") {
      return <>Conversation deleted. <br /><span className="redirect-link text-decoration-none" onClick={redirectToChat}>Undo.</span></>
    }
    if (notificationData.notificationType == "CUSTOM") {
      return <>{notificationData.text}</>;
    }
    return <></>;
  };
  return (
    <div className="app-notification-container">
      <GetTextLink />
    </div>
  );
};

const ChatUserImage = ({ message }) => {
  const hasImage = message.senderImage != null && message.senderImage != "";
  const userShortName = () => {
    let finalName = "";
    // if (message.senderAbbreviation != null && message.senderAbbreviation != "") {
    //     finalName = message.senderAbbreviation;
    // }
    // else {
    const names = message.senderName.split(" ");
    names.forEach((x) => (finalName = finalName.concat([x.charAt(0)])));
    // }
    return finalName;
  };
  return (
    <div
      style={{
        backgroundColor: "#95A7C6",
        border: "2px solid #FFFFFF",
        height: "45px",
        width: "45px",
        overflow: "hidden",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      {hasImage ? (
        <img src={message.senderImage} width="100%" />
      ) : (
        <span
          style={{
            color: "#FFFFFF",
            fontSize: "14px",
            fontWeight: "bold",
            lineHeight: "19px",
          }}>
          {userShortName()}
        </span>
      )}
    </div>
  );
};
